import React, { Suspense } from 'react';

class ErrorBoundary extends React.Component {
  componentDidCatch(error) {
    // If it's a chunk load error, refresh the page directly
    if (error.name === 'ChunkLoadError' || error.message?.includes('Loading chunk') || error.message?.includes('fetch')) {
      window.location.reload(true);
    }
  }

  render() {
    return this.props.children;
  }
}

const LazyWrapper = ({ component: Component }) => (
  <ErrorBoundary>
    <Suspense fallback={<div>Loading...</div>}>
      <Component />
    </Suspense>
  </ErrorBoundary>
);

export default LazyWrapper;